var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          id: "unexpected_door_opening@1x-a",
          d:
            "M15.5052834,8.12742459 L8.15792096,8.12742459 L8.15792096,7.78696137 C8.15792096,7.00887834 8.77158516,5.96008553 9.55049858,5.82140905 C9.56378495,5.81891785 10.940585,5.54322568 11.8316022,5.54322568 C12.7201282,5.54322568 14.0969282,5.81808745 14.0977586,5.81808745 C14.9397823,6.00575743 15.5052834,6.98728799 15.5052834,7.78696137 L15.5052834,8.12742459 Z M14.2596862,19.8792186 L9.40268772,19.8792186 C8.71677889,19.8792186 8.15792096,19.3211911 8.15792096,18.6352822 L8.15792096,9.62214118 L15.5052834,9.62214118 L15.5052834,18.6352822 C15.5052834,19.3211911 14.9464255,19.8792186 14.2596862,19.8792186 L14.2596862,19.8792186 Z M9.55049858,3.77281692 C9.56378495,3.76949533 10.9430762,3.49463355 11.8316022,3.49463355 C12.7201282,3.49463355 14.0969282,3.76949533 14.0977586,3.76949533 C14.5735767,3.87578628 14.9563903,4.23867026 15.2038489,4.67629006 C14.9580511,4.53844397 14.6973061,4.42052744 14.4074971,4.35575639 C14.3460477,4.34330042 12.8704302,4.04850909 11.8316022,4.04850909 C10.7936046,4.04850909 9.31715672,4.34330042 9.27231522,4.35326519 C8.98997986,4.40308908 8.73172605,4.51270163 8.48675861,4.64722612 C8.74086043,4.21043672 9.11786117,3.85004394 9.55049858,3.77281692 L9.55049858,3.77281692 Z M11.8316022,1.99991696 C10.7936046,1.99991696 9.31715672,2.29470829 9.27231522,2.30384267 C7.71199718,2.58119563 6.66403477,4.30344131 6.66403477,5.73836924 L6.66403477,5.82140905 C6.66071317,5.82473064 6.65656118,5.82639144 6.65323959,5.82888263 L3.27769494,8.65352355 C3.00283317,8.96160125 3.03023631,9.43409777 3.3391444,9.70812915 C3.48114248,9.83518006 3.65884768,9.89745992 3.83572247,9.89745992 C4.0416612,9.89745992 4.24676954,9.81275931 4.39375,9.64667969 L6.66403477,8.06680553 L6.66403477,18.6352822 C6.66403477,20.1457764 7.89219357,21.3739352 9.40268772,21.3739352 L14.2596862,21.3739352 C15.7710108,21.3739352 17,20.1457764 17,18.6352822 L17,5.73836924 C17,4.33582683 16.0359078,2.67004823 14.4074971,2.30716426 C14.3460477,2.29470829 12.8704302,1.99991696 11.8316022,1.99991696 Z"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("use", {
        attrs: {
          fill: _vm.currentColor,
          opacity: _vm.opacity,
          "fill-rule": "nonzero",
          "xlink:href": "#unexpected_door_opening@1x-a"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }